var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton",class:[
    { 'skeleton__item': _vm.items === 1 },
    { error: _vm.error }
  ]},[(_vm.items > 1)?_vm._l((_vm.items),function(num){return _c('div',{key:num,class:[ 'skeleton__item', _vm.className, { error: _vm.error }]})}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }